import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputTelAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['value'],
    ['placeholder', '+1-999-555-5555'],
    ['required', false],
    ['pattern', '^(\\+\\d{1,3}[.\\- ]?)?(\\(?\\d{1,4}\\)?[.\\- ]?)?\\d{1,4}[.\\- ]?\\d{1,4}([.\\- ]?\\d{1,9})?$'],
    ['maxLength', '15'],
    ['minLength', '10'],
    ['type', HTTPINPUTTYPE.TEL]
]);
export const inputTelData = makeDataStruct([]);
export const inputTelModel = makeStruct([
    ['attributes', inputTelAttr],
    ['data', inputTelData]
]);
// Simplified Model
export function inputTel(name, className, value, placeholder, required, maxLength, minLength, pattern) {
    return {
        attributes: inputTelAttr(name, className, value, placeholder, required, maxLength, minLength, pattern),
        data: inputTelData()
    };
}
// Class
export default class INPUTTEL extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
}
